import { render, staticRenderFns } from "./DemoRainbow.vue?vue&type=template&id=776478b4"
import script from "./DemoRainbow.vue?vue&type=script&lang=js"
export * from "./DemoRainbow.vue?vue&type=script&lang=js"
import style0 from "./DemoRainbow.vue?vue&type=style&index=0&id=776478b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports